/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ActionAudDto interface.
 */
export function instanceOfActionAudDto(value) {
    return true;
}
export function ActionAudDtoFromJSON(json) {
    return ActionAudDtoFromJSONTyped(json, false);
}
export function ActionAudDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'idUtente': json['idUtente'] == null ? undefined : json['idUtente'],
        'action': json['action'] == null ? undefined : json['action'],
        'request': json['request'] == null ? undefined : json['request'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
    };
}
export function ActionAudDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'idUtente': value['idUtente'],
        'action': value['action'],
        'request': value['request'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString()),
    };
}
